import React from 'react';

const Vision = () => {
  const missions = [
    'Memberdayakan petani dan peternak lokal melalui program kemitraan yang saling menguntungkan',
    'Menyediakan produk berkualitas tinggi dengan standar halal dan organik',
    'Mengembangkan teknologi dan inovasi dalam bidang pertanian berkelanjutan',
    'Membangun ekosistem agribisnis yang berkelanjutan dan ramah lingkungan'
  ];

  return (
    <section id="visi-misi" className="pt-20 sm:pt-24 pb-16 sm:pb-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center bg-primary/10 text-primary px-3 py-2 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4">
            <i className="fa-solid fa-bullseye mr-2"></i>
            Visi & Misi
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4 sm:mb-6">
            Komitmen Kami untuk<br className="hidden sm:block"/>
            <span className="text-secondary">Masa Depan Berkelanjutan</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="space-y-12">
            <div className="bg-gradient-to-br from-primary to-secondary rounded-3xl p-6 sm:p-8 text-white">
              <div className="flex items-center mb-4 sm:mb-6">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mr-4">
                  <i className="fa-solid fa-eye text-xl sm:text-2xl"></i>
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold">Visi Kami</h3>
              </div>
              <p className="text-base sm:text-lg md:text-xl leading-relaxed">
                Menjadi perusahaan agribisnis terdepan di Indonesia yang 
                mensejahterakan petani dan peternak melalui inovasi berkelanjutan, 
                kemitraan yang kuat, dan komitmen terhadap kualitas produk halal dan organik.
              </p>
            </div>

            <div className="bg-light-bg rounded-3xl p-6 sm:p-8">
              <div className="flex items-center mb-4 sm:mb-6">
                <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mr-4">
                  <i className="fa-solid fa-rocket text-primary text-xl sm:text-2xl"></i>
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold text-primary">Misi Kami</h3>
              </div>
              <div className="space-y-4">
                {missions.map((mission, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                      <span className="text-primary font-bold text-xs sm:text-sm">{index + 1}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                      {mission}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="space-y-6 sm:space-y-8">
            <div className="relative">
              <img className="w-full h-56 sm:h-72 md:h-[360px] lg:h-[400px] object-cover rounded-2xl shadow-xl" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/703ce600e5-39f6228225756f12d2e1.png" alt="Indonesian sustainable farming community, farmers working together in harmony with nature" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent rounded-2xl"></div>
              <div className="absolute bottom-6 sm:bottom-8 left-6 sm:left-8 text-white max-w-xs sm:max-w-sm">
                <h4 className="text-xl sm:text-2xl font-bold mb-2">Komunitas Berkelanjutan</h4>
                <p className="text-sm sm:text-lg">Membangun masa depan pertanian Indonesia</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 sm:gap-6">
              <div className="bg-white border border-gray-100 rounded-2xl p-5 sm:p-6 text-center shadow-lg">
                <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="fa-solid fa-seedling"></i>
                </div>
                <div className="text-xl sm:text-2xl font-bold text-primary mb-1 sm:mb-2">100+</div>
                <div className="text-xs sm:text-sm text-gray-600">Hektar Lahan Organik</div>
              </div>
              <div className="bg-white border border-gray-100 rounded-2xl p-5 sm:p-6 text-center shadow-lg">
                <div className="w-12 h-12 bg-secondary text-white rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="fa-solid fa-users"></i>
                </div>
                <div className="text-xl sm:text-2xl font-bold text-primary mb-1 sm:mb-2">200+</div>
                <div className="text-xs sm:text-sm text-gray-600">Petani Mitra</div>
              </div>
            </div>

            <div className="bg-accent/10 rounded-2xl p-6 sm:p-8 text-center">
              <h4 className="text-xl sm:text-2xl font-bold text-primary mb-3 sm:mb-4">Komitmen Lingkungan</h4>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                Kami berkomitmen mengurangi jejak karbon melalui praktik pertanian 
                berkelanjutan dan penggunaan energi terbarukan di semua fasilitas kami.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;

